module.exports = __webpack_public_path__ + "static/img/empty.c643e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/empty.png
// module id = daAF
// module chunks = 216